<script>import OptionIcon from "@twist/icons/lib/Option.svg?component";
import OptionCheckedIcon from "@twist/icons/lib/OptionChecked.svg?component";
import { createEventDispatcher } from "svelte";
export let checked = false;
export let color = "gray-0";
export let label = "";
$:
  icon = checked ? OptionCheckedIcon : OptionIcon;
const dispatch = createEventDispatcher();
function onClick() {
  checked = !checked;
  dispatch("change", { checked });
}
function onKeyDown(e) {
  if (e.code === "Enter") {
    onClick();
  }
}
</script>

<div
  tabindex="0"
  role="checkbox"
  class="twist-checkbox"
  aria-checked={checked}
  aria-label={label}
  on:click={onClick}
  on:keydown={onKeyDown}
  style={`--color: var(--twist-color-${color});`}
>
  <svelte:component this={icon} height="100%" />
</div>

<style>div {
  cursor: pointer;
  display: inline-block;
  width: inherit;
  height: inherit;
  color: var(--color);
}</style>
